import App from "@/App.tsx";
import logoUrl from "@/assets/images/logo.svg";
import { Text } from "@mantine/core";
import { Outlet } from "react-router";
import packageJson from "@/../package.json";

export function AuthLayout() {
  return (
    <App>
      <div className="w-full h-screen overflow-hidden">
        <div className="flex flex-col gap-2 items-center justify-center py-12 h-full">
          <img src={logoUrl} className="h-16" alt="" />
          <Outlet />
          <Text size="sm" c="dimmed" mt={10}>
            v.{packageJson.version}
          </Text>
        </div>
      </div>
    </App>
  );
}
